import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { GeneratedIdea, GeneratedIdeasResponse } from '../../components/campaigns/types';

interface CompetitiveIdeasState {
  data: GeneratedIdea[];
  loading: boolean;
  error: string | null;
  count: number;
}

const initialState: CompetitiveIdeasState = {
  data: [],
  loading: false,
  error: null,
  count: 0,
};

const competitiveIdeasSlice = createSlice({
  name: 'competitiveIdeas',
  initialState,
  reducers: {
    fetchCompetitiveIdeasRequest: (state, _action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    fetchCompetitiveIdeasSuccess: (state, action: PayloadAction<GeneratedIdeasResponse>) => {
      state.loading = false;
      state.data = action.payload.data;
      state.count = action.payload.count;
      state.error = null;
    },
    fetchCompetitiveIdeasFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchCompetitiveIdeasRequest,
  fetchCompetitiveIdeasSuccess,
  fetchCompetitiveIdeasFailure,
} = competitiveIdeasSlice.actions;

export default competitiveIdeasSlice.reducer;
